import { ApiResponse } from './api';

export interface Platform {
  id: number;
  name: string;
  displayName: string;
  description?: string;
}

export interface PlatformAccount {
  id: string;
  customerId: string;
  categoryId?: number;
  platformId: number;
  platformAccountId?: string;
  username: string;
  displayName?: string;
  profileUrl?: string;
  profilePicUrl?: string;
  originalAvatarUrl?: string;
  followerCount?: number;
  followingCount?: number;
  friendsCount?: number;
  totalHearts?: number;
  totalVideos?: number;
  totalDiggs?: number;
  postCount?: number; // For backward compatibility/display
  verified?: boolean;
  isPrivate?: boolean;
  bioSignature?: string;
  bioLink?: string;
  region?: string;
  roomId?: string;
  isTtSeller?: boolean;
  emvViewRate?: number;
  emvLikeRate?: number;
  emvCommentRate?: number;
  emvShareRate?: number;
  isActive: boolean;
  lastSyncAt?: string;
  createdAt: string;
  updatedAt: string;
  platform?: Platform;
  customer?: {
    id: string;
    customerName: string;
  };
}

export interface CreatePlatformAccountRequest {
  customerId: string;
  categoryId?: number;
  platformId: number;
  platformAccountId?: string;
  username: string;
  displayName?: string;
  profileUrl?: string;
  profilePicUrl?: string;
  originalAvatarUrl?: string;
  followerCount?: number;
  followingCount?: number;
  friendsCount?: number;
  totalHearts?: number;
  totalVideos?: number;
  totalDiggs?: number;
  verified?: boolean;
  isPrivate?: boolean;
  bioSignature?: string;
  bioLink?: string;
  region?: string;
  roomId?: string;
  isTtSeller?: boolean;
  emvViewRate?: number;
  emvLikeRate?: number;
  emvCommentRate?: number;
  emvShareRate?: number;
  isActive?: boolean;
}

export interface UpdatePlatformAccountRequest {
  categoryId?: number;
  platformAccountId?: string;
  username?: string;
  displayName?: string;
  profileUrl?: string;
  profilePicUrl?: string;
  originalAvatarUrl?: string;
  followerCount?: number;
  followingCount?: number;
  friendsCount?: number;
  totalHearts?: number;
  totalVideos?: number;
  totalDiggs?: number;
  verified?: boolean;
  isPrivate?: boolean;
  bioSignature?: string;
  bioLink?: string;
  region?: string;
  roomId?: string;
  isTtSeller?: boolean;
  emvViewRate?: number;
  emvLikeRate?: number;
  emvCommentRate?: number;
  emvShareRate?: number;
  isActive?: boolean;
}

export interface PlatformAccountsResponse extends ApiResponse<{
  platformAccounts: PlatformAccount[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}> {}

export interface PlatformAccountResponse extends ApiResponse<{
  platformAccount: PlatformAccount;
}> {}

// Platform constants
export const PLATFORMS = {
  INSTAGRAM: 1,
  TIKTOK: 2,
  FACEBOOK: 3,
  TWITTER: 4,
  YOUTUBE: 5,
} as const;

export const PLATFORM_NAMES = {
  [PLATFORMS.INSTAGRAM]: 'instagram',
  [PLATFORMS.TIKTOK]: 'tiktok',
  [PLATFORMS.FACEBOOK]: 'facebook',
  [PLATFORMS.TWITTER]: 'twitter',
  [PLATFORMS.YOUTUBE]: 'youtube',
} as const;

export const PLATFORM_DISPLAY_NAMES = {
  [PLATFORMS.INSTAGRAM]: 'Instagram',
  [PLATFORMS.TIKTOK]: 'TikTok',
  [PLATFORMS.FACEBOOK]: 'Facebook',
  [PLATFORMS.TWITTER]: 'Twitter',
  [PLATFORMS.YOUTUBE]: 'YouTube',
} as const;